import React, { useState } from "react";

const Alert = (alert, i) => {
  const [showAlert, setShowAlert] = useState(true);

  const handleClick = (alertId) => {
    setShowAlert(false);

    let newAlerts = window.localStorage.getItem("hideAlerts")
      ? JSON.parse(window.localStorage.getItem("hideAlerts"))
      : [];

    if (!newAlerts.includes(alertId)) {
      newAlerts.push(alertId);
      window.localStorage.setItem("hideAlerts", [JSON.stringify(newAlerts)]);
    }
  };

  if (showAlert) {
    return (
      <div key={i} className="alert alert-warning mt-4 mb-2  mx-2" role="alert">
        <h2 className="alert-title">{alert.title}</h2>
        <p className="pb-0 mb-0 alert-message">{alert.message}</p>
        <button
          className="alert-close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={() => handleClick(alert.id)}
        >
          <span aria-hidden="true">
            <i className="fas fa-times"></i>
          </span>
        </button>
      </div>
    );
  } else {
    return null;
  }
};

export default Alert;
